import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion/dist/framer-motion";

/* Persistent skip-level button + collapsible "How to play" panel.
   Sits inside the game stage, above gameplay, below overlays. */
export const GameControls = ({ onSkip, controls = [], helpDefaultOpen = false }) => {
  const [helpOpen, setHelpOpen] = useState(helpDefaultOpen);

  return (
    <div className="md-game-controls">
      <button
        className="md-mini-btn md-help-toggle"
        onClick={() => setHelpOpen((o) => !o)}
        aria-label="how to play"
      >
        {helpOpen ? "✕ close" : "? how to play"}
      </button>

      {onSkip && (
        <button
          className="md-mini-btn md-skip-btn"
          onClick={onSkip}
          aria-label="skip level"
        >
          skip ⤳
        </button>
      )}

      <AnimatePresence>
        {helpOpen && (
          <motion.div
            className="md-help-panel"
            initial={{ y: -10, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: -10, opacity: 0 }}
            transition={{ duration: 0.2 }}
          >
            <div className="md-help-title">How to play</div>
            <ul>
              {controls.map((c, i) => (
                <li key={i}>
                  {c.keys && (
                    <span className="md-help-keys">
                      {c.keys.map((k, j) => (
                        <kbd key={j}>{k}</kbd>
                      ))}
                    </span>
                  )}
                  <span className="md-help-text">{c.label}</span>
                </li>
              ))}
            </ul>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default GameControls;
